<template>
  <div class="profile">
    <list
      v-if="showList"
      @go-to-tree="goToTree()"
      @show-linked-users="showLinkedUsers"
      @delete-profiles="deleteProfile"
    />
    <tree
      v-else-if="showTree"
      @back-to-list="goToList()"
      @show-linked-users="showLinkedUsers"
      @delete-profiles="deleteProfile"
    />
    <profile-delete-modal
      v-model="profileDeleteModalShow"
      ref="profileDeleteModal"
      :validationRemoveData="removeProfileData"
    />
    <linked-users-list-modal
      v-model="linkedUsersModalShow"
      :profilesIds="profilesIdsToShowUsers"
      :filterOnlySelectedProfile="filterOnlySelectedProfile"
    />
  </div>
</template>

<script>
import Service from '@/domain/services/generalPanel/adminPanel/profile/profileService';
import List from '@/domain/components/generalPanel/adminPanel/profile/List';
import Tree from '@/domain/components/generalPanel/adminPanel/profile/Tree';
import ProfileDeleteModal from '@/domain/components/generalPanel/adminPanel/profile/ProfileDeleteModal';
import LinkedUsersListModal from '@/domain/components/generalPanel/adminPanel/profile/LinkedUsersListModal';
import GlobalUserService from '@/services/user';

const modes = {
  TREE: 'tree',
  LIST: 'list',
};

export default {
  components: {
    List,
    Tree,
    ProfileDeleteModal,
    LinkedUsersListModal,
  },
  data: () => ({
    mode: modes.LIST,
    profilesIdsToShowUsers: null,
    filterOnlySelectedProfile: false,
    removeProfileData: null,
    linkedUsersModalShow: false,
    profileDeleteModalShow: false,
  }),
  created() {
    GlobalUserService.validateUserPermission('PER002');
  },
  computed: {
    showList() {
      return this.mode === modes.LIST;
    },
    showTree() {
      return this.mode === modes.TREE;
    },
  },
  methods: {
    goToTree() {
      this.mode = modes.TREE;
    },
    goToList() {
      this.mode = modes.LIST;
    },
    showLinkedUsers(event) {
      this.profilesIdsToShowUsers = event.profilesIds;
      this.filterOnlySelectedProfile = event.filterOnlySelectedProfile;
      this.linkedUsersModalShow = true;
    },
    deleteProfile({ ids, callback }) {
      Service.deleteProfiles(ids, usersData => this.confirmDeleteProfile(usersData))
        .then(() => {
          callback(true);
          this.$pushAlert({ code: 'MS007' });
        });
    },
    confirmDeleteProfile(dataToShow) {
      this.removeProfileData = dataToShow;
      return this.$refs.profileDeleteModal.show();
    },
  },
};
</script>
